import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { default as UsuarioEdit } from "../../components/Usuario/edit";
import { default as UsuarioNew } from "../../components/Usuario/new";
import { sagaGetUsuarioById, sagaSaveUsuario } from "../../reducers/usuarioReducer/actions";
import { usuarioEditSelector, usuarioRolSelector } from "../../selectors/usuarioSelector";
import { instalacionSelector } from "../../selectors/sessionSelector";
import { usuarioSelector, sucursalSelector } from "../../selectors/sessionSelector";
import { sagaFetchUsuarioLogeado } from "../../reducers/sessionReducer/actions";
import {
  sagaEliminarUsuario,
  sagaReactivarUsuario,
  sagaAgregarListaBlanca,
  sagaEliminarListaBlanca,
  sagaAgregarListaNegra,
  sagaEliminarListaNegra,
  sagaSetSucursalesUsuario,
} from "../../reducers/usuarioReducer/actions";
import _axios from "../../apiClient";

class UsuarioEditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: {
        nombre: "",
      },
      preUsuario: {
        nombre: "",
      },
      cargandoUsuario: true,
      error: undefined,
      usuarioCargado: false,
      editDatos: false,
      editSeguridad: false,
      editSucursales: false,
      valido: undefined,
      sucursales: undefined,
    };
    // busco los datos iniciales
    let id = props.match.params.idUsuario;
    if (id === "0") id = null;
    props.sagaGetUsuarioById(id);
  }

  setEditDatos = (e) => {
    this.setState({
      editDatos: e,
    });
  };

  setEditSeguridad = (e) => {
    this.setState({
      editSeguridad: e,
    });
  };

  setEditSucursales = (e) => {
    this.setState({
      editSucursales: e,
    });
  };

  componentDidUpdate = async () => {
    if (this.state.usuarioCargado === false && this.props.usuarioLogueado !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuarioLogueado.idRol !== 1) {
          window.location.hash = "/";
        }
      });
    }

    if (!this.state.sucursales) {
      await _axios
        .get(`/api/sucursal/GetSucursalesInstalacion?idInstalacion=${this.props.instalacion.id}`)

        .then((response) => {
          this.setState({ sucursales: response.data });
        })
        .catch((error) => {
          const data = error.response.data;
          throw data;
        });
    }
    /*if(prevProps.usuario.id && (prevProps.usuario !== this.state.usuario)){
            this.setState({usuario: prevProps.usuario, cargandoUsuario:false}, ()=>{this.render()})
        }*/
  };

  UNSAFE_UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.cargandoUsuario && nextProps.usuario.id !== undefined) {
      this.setState(
        { usuario: nextProps.usuario, preUsuario: nextProps.usuario, cargandoUsuario: false },
        () => {
          this.render();
        }
      );
    }
    this.render();
  }

  validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  valido() {
    let u = this.state.usuario;
    let error = { valido: true };
    if (u.email === "" || u.email === null) {
      error.email = "debe definir un email de usuario";
      error.valido = false;
    } else if (!this.validateEmail(u.email)) {
      error.email = "debe definir un email valido";
      error.valido = false;
    }

    if (u.nombre === "" || u.nombre === null) {
      error.nombre = "debe definir un nombre";
      error.valido = false;
    }
    if (u.apellido === "" || u.apellido === null) {
      error.apellido = "debe definir un apellido";
      error.valido = false;
    }
    if (u.tipoRol === 1) {
      if (u.nombreUsuario === "" || u.nombreUsuario === null) {
        error.nombreUsuario = "debe definir un nombre de usuario";
        error.valido = false;
      }
      if (u.rol === "" || u.rol === null) {
        error.rol = "debe definir un rol de usuario";
        error.valido = false;
      }
    }
    if (error.valido) {
      this.setState({ error: undefined });
      return true;
    } else {
      this.setState({ error });
      return false;
    }
  }

  setListaBlanca = (newState) => {
    if (newState) {
      this.props.sagaAgregarListaBlanca(this.state.usuario.id);
    } else {
      this.props.sagaEliminarListaBlanca(this.state.usuario.id);
    }
  };

  setListaNegra = async (newState) => {
    if (newState) {
      this.props.sagaAgregarListaNegra(this.state.usuario.id);
    } else {
      this.props.sagaEliminarListaNegra(this.state.usuario.id);
    }
  };

  handleOnSave = async () => {
    if (this.valido()) {
      this.setState({ cargandoUsuario: false });
      this.props.sagaSaveUsuario({
        ...this.state.usuario,
        idInstalacion: this.props.instalacion.id,
      });
      this.setEditDatos(false);
    } else if (this.state.error) {
      this.setEditDatos(true);
    }
  };

  render() {
    if (this.state.cargandoUsuario) return <div></div>;

    if (this.state.usuario.id !== null) {
      return (
        <UsuarioEdit
          instalacion={this.props.instalacion}
          usuario={this.state.usuario}
          error={this.state.error}
          roles={this.props.roles}
          sucursales={this.state.sucursales}
          getPreUsuario={() => {
            this.setState({
              usuario: this.state.preUsuario,
              error: false,
            });
          }}
          setSucursales={(sucursales) => {
            const idSucursalesActivas = [];
            const idScursalesDesactivas = [];
            this.state.sucursales.map((sucursal) => {
              if (sucursales.map((x) => x.idSucursal).includes(sucursal.idSucursal)) {
                idSucursalesActivas.push(sucursal.idSucursal);
              } else {
                idScursalesDesactivas.push(sucursal.idSucursal);
              }
            });
            this.props.sagaSetSucursalesUsuario(
              this.state.usuario.id,
              idSucursalesActivas,
              idScursalesDesactivas,
              this.props.usuarioLogueado.id,
              this.props.sucursal.idSucursal
            );
            this.setState({
              usuario: {
                ...this.state.usuario,
                sucursalUsuarios: sucursales,
              },
            });
            /*if(this.props.usuarioLogueado.id === this.state.usuario.id){
                        window.location.hash = '/SeleccionSucursal'
                    }*/
          }}
          setEditDatos={(newEdit) => {
            this.setEditDatos(newEdit);
          }}
          setEditSeguridad={(newEdit) => {
            this.setEditSeguridad(newEdit);
          }}
          setEditSucursales={(newEdit) => {
            this.setEditSucursales(newEdit);
          }}
          setListasActivo={(newStateListaBlanca, newStateListaNegra, active) => {
            if (active !== this.state.usuario.activo) {
              if (active) this.props.sagaReactivarUsuario(this.state.usuario.id);
              else this.props.sagaEliminarUsuario(this.state.usuario.id);
              this.setState({
                usuario: {
                  ...this.state.usuario,
                  activo: active,
                },
              });
            }
            if (newStateListaBlanca !== this.state.usuario.cliente.listaBlancaActive) {
              this.setListaBlanca(newStateListaBlanca);
            }
            if (newStateListaNegra !== this.state.usuario.cliente.listaNegraActive) {
              this.setListaNegra(newStateListaNegra);
            }
            this.setState({
              usuario: {
                ...this.state.usuario,
                activo: active,
                cliente: {
                  ...this.state.usuario.cliente,
                  listaNegraActive: newStateListaNegra,
                  listaBlancaActive: newStateListaBlanca,
                },
              },
            });
          }}
          setDNI={(x) => {
            //console.log(x);
            this.setState({
              usuario: {
                ...this.state.usuario,
                cliente: {
                  ...this.state.usuario.cliente,
                  dni: x.value,
                },
              },
            });
          }}
          handleOnChange={(x) => {
            if (x.target.name === "email") {
              this.setState({ valido: this.validateEmail(x.target.value) });
            }
            this.setState({
              usuario: {
                ...this.state.usuario,
                ...pathValue(x.target.name.split(".").reverse(), x.target.value),
              },
            });
          }}
          handleOnCancel={() => {
            this.props.history.goBack();
          }}
          handleOnSave={() => {
            this.handleOnSave();
          }}
          setPorcentajeDescuento={(x) => {
            this.setState({
              usuario: {
                ...this.state.usuario,
                cliente: {
                  ...this.state.usuario.cliente,
                  porcentajeDescuentoFullCatalogo: x.value,
                },
              },
            });
          }}
          handleOnSave2={() => {
            this.handleOnSave();
          }}
          editDatos={this.state.editDatos}
          editSeguridad={this.state.editSeguridad}
          editSucursales={this.state.editSucursales}
          valido={this.state.valido}
        />
      );
    } else {
      return (
        <UsuarioNew
          usuario={this.state.usuario}
          error={this.state.error}
          roles={this.props.roles}
          handleOnChange={(x) => {
            //console.log(x);
            this.setState({
              usuario: {
                ...this.state.usuario,
                ...pathValue(x.target.name.split(".").reverse(), x.target.value),
              },
            });
          }}
          handleOnCancel={() => {
            this.props.history.goBack();
          }}
          handleOnSave={() => {
            if (this.valido()) {
              this.setState({ cargandoUsuario: false });
              this.props.sagaSaveUsuario(
                { ...this.state.usuario, idInstalacion: this.props.instalacion.id },
                this.props.history
              );
            }
          }}
        />
      );
    }
  }
}

function pathValue(path, value) {
  if (path.length === 1) {
    return { [path[0]]: value };
  } else {
    let p = path.pop();
    return { [p]: pathValue(path, value) };
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetUsuarioById,
      sagaSaveUsuario,
      sagaEliminarUsuario,
      sagaReactivarUsuario,
      sagaAgregarListaBlanca,
      sagaEliminarListaBlanca,
      sagaAgregarListaNegra,
      sagaEliminarListaNegra,
      sagaSetSucursalesUsuario,
      sagaFetchUsuarioLogeado,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuario: usuarioEditSelector(state),
    roles: usuarioRolSelector(state),
    sucursal: sucursalSelector(state),
    instalacion: instalacionSelector(state),
    usuarioLogueado: usuarioSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsuarioEditContainer);
